module.exports = __webpack_public_path__ + "media/img/decorations/history-bl-img-b7128c34f62ac864dc36ded81fafea80.svg";